import "./css/doubt-body.css";

const DoubtBody = ({ title, desc }) => {
    return (
        <div className="doubt-body">
            <span className="title b-title">{title}</span>

            <span className="dbt-bdy-desc">
                {desc.split("\n").map((text, key) => {
                    return (
                        <span key={key}>
                            {text}
                            <br />
                        </span>
                    );
                })}
            </span>
        </div>
    );
}

export default DoubtBody;